<div class="language-selector">
	<p-dropdown [options]="languages" [(ngModel)]="selectedLanguage" optionLabel="name" (onChange)="onLanguageChange($event.value)" [style]="{ 'min-width': '150px' }" placeholder="Select Language" [appendTo]="'body'">
		<ng-template let-language pTemplate="selectedItem">
			<div class="language-item">
				<span class="material-symbols-outlined globe-icon">language</span>
				<span>{{ language.name }}</span>
			</div>
		</ng-template>
	</p-dropdown>
</div>
